/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  Table,
  Input,
  Spin,
} from "antd";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { RiAddCircleFill, RiCloseCircleLine } from "react-icons/ri";
import PropertyImg from "../../../assets/images/houseImg.svg";
import AboutProperty from "./components/AboutProperty";
import AdditionalFees from "./components/AdditionalFees";
import Amenities from "./components/Amenities";
import BankAccounts from "./components/BankAccounts";
import LeaseSetting from "./components/LeaseSetting";
import MaintenanceInformation from "./components/MaintenanceInformation";
import MarketingInformation from "./components/MarketingInformation";
import NonRevenueStatus from "./components/NonRevenueStatus";
import OwnersAndFinancial from "./components/OwnersAndFinancial";
import PropertyGroups from "./components/PropertyGroups";
import PropertyInformation from "./components/PropertyInformation";
import RentalInformation from "./components/RentalInformation";
import StatementSettings from "./components/StatementSettings";
import UpComingActivities from "./components/UpComingActivities";
import LateFeePolicy from "./components/LateFeePolicy";

import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import ConfirmationBox from "../../../components/common/ConfirmationBox";
import { contactinfo } from "../../../data/renewals";
import { months, packets, payee } from "./property";
import ManagementFees from "./components/ManagementFees";
import Notes from "../../../components/common/Notes";
import AttachmentsUpload from "../../../components/common/AttachmentsUpload";
import EmailRentalApplication from "../../../components/common/EmailRentalApplication";
import PostToWebsite from "../../../components/common/PostToWebsite";
import PostToInternet from "../../../components/common/PostToInternet";
import TextArea from "antd/es/input/TextArea";
import Email from "../../../components/common/Email";
import { toast } from "react-hot-toast";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
  onSnapshot,
} from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { v4 as uuidv4 } from "uuid";

const PropertyItemPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [postToWebsiteOpen, setPostToWebsiteOpen] = useState(false);
  const [postToInternetOpen, setPostToInternetOpen] = useState(false);
  const [newOwnerShipShow, setNewOwnerShipShow] = useState(false);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);

  const [value, setValue] = useState("net income");
  const [hidingReason, setHidingReason] = useState("");
  const [isHidePropertyShow, setIsHidePropertyShow] = useState(false);
  const [textPropertyShow, setTextPropertyShow] = useState();
  const [count, setCount] = useState(0);
  const [ownership, setOwnership] = useState(false);
  const [notes, setNotes] = useState([]);

  const [isKeyModalOpen, setIsKeyModalOpen] = useState(false);
  console.log("ownership", ownership);
  const [keyId, setKeyId] = useState("");
  const [isUpdateValue, setIsUpdateValue] = useState(false);

  const showKeyModal = (id, todo) => {
    setIsKeyModalOpen(true);
    setKeyId(id);
    if (todo === "add") {
      setIsUpdateValue(false);
    } else if (todo === "update") {
      setIsUpdateValue(true);
    }
  };

  const handleCancel = () => {
    setIsKeyModalOpen(false);
  };
  const [totalPercentage, setTotalPercentage] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const handleUrl = () => {
    window.open("/inspection", "_blank");
  };
  const PropertyRightbar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod("New Property", "1", "", "", "/properties/new"),
      RightBarMethod(
        "New Property Group",
        "2",
        "",
        "",
        "/generalsettings/new-property-groups"
      ),
      RightBarMethod(
        <Button
          type="link"
          disabled={ownership ? false : true}
          onClick={() => setNewOwnerShipShow(true)}
          style={{ padding: "0" }}
        >
          New Ownership
        </Button>,
        "3",
        "",
        "",
        ""
      ),
      RightBarMethod("New Rentable Item", "4", "", "", ""),
      RightBarMethod(
        "Move In Tenant",
        "5",
        "",
        "",
        "/people/tenants/move-in-tenant"
      ),
      RightBarMethod("Increase Rent", "6", "", "", "/rent_increase"),
      RightBarMethod(
        <span onClick={() => setIsConfirmationBoxOpen(true)}>
          Email Rental Application
        </span>,
        "7",
        "",
        "",
        ""
      ),
      RightBarMethod(
        "New Service Request",
        "8",
        "",
        "",
        "/maintenance/work-orders/service-requests/new"
      ),
      RightBarMethod("Work Orders", "9", "", "", "/maintenance/work-orders"),
      RightBarMethod("Purchase Orders", "10", "", "", ""),
      RightBarMethod(
        <span onClick={handleUrl}>New Inspection</span>,
        "11",
        "",
        "",
        ""
      ),
      RightBarMethod("View Inspections", "12", "", "", ""),
      RightBarMethod("View Unit Turn Board", "13", "", "", ""),
      RightBarMethod(
        <span onClick={() => setTextPropertyShow(true)}>Text Property</span>,
        "14",
        "",
        "",
        ""
      ),
      RightBarMethod(
        <span onClick={() => setIsHidePropertyShow(true)}>Hide Property</span>,
        "15",
        "",
        "",
        ""
      ),
      RightBarMethod(
        <span onClick={showModal}>Email Property</span>,
        "31",
        "",
        "",
        ""
      ),
      RightBarMethod(
        "End Management",
        "16",
        "",
        "",
        `/property-page/end-management/${id}`
      ),
    ]),
    RightBarMethod("Marketing", "t2", <i className="fa-solid fa-globe"></i>, [
      RightBarMethod("Refresh Posting ", "17", "", "", ""),
      RightBarMethod(
        <span onClick={() => setPostToWebsiteOpen(true)}>Post to Website</span>,
        "18",
        "",
        "",
        ""
      ),
      RightBarMethod(
        <span onClick={() => setPostToInternetOpen(true)}>
          Post to Internet
        </span>,
        "19",
        "",
        "",
        ""
      ),
      RightBarMethod("Activate Premium Leads", "20", "", "", ""),
      RightBarMethod("Post Vacancy Manually", "21", "", "", ""),
      RightBarMethod("Download Marketing Flyer", "22", "", "", ""),
    ]),
    RightBarMethod(
      " REPORTS",
      "t3",
      <i className="fa-solid fa-chart-column"></i>,
      [
        RightBarMethod("Property Directory", "23", "", "", "/"),
        RightBarMethod("Unit Directory", "24", "", "", "/"),
        RightBarMethod("Rent Roll", "25", "", "", "/"),
        RightBarMethod("Unit Vacancy Detail", "26", "", "", "/"),
        RightBarMethod("General Ledger", "27", "", "", "/"),
        RightBarMethod("Work Order", "28", "", "", "/"),
        RightBarMethod("Activities Summary", "29", "", "", "/"),
      ]
    ),
    RightBarMethod(
      " LETTERS",
      "t4",
      <i className="fa-solid fa-file-lines"></i>,
      [RightBarMethod("Send Statements", "30", "", "", "/")]
    ),
  ];
  // const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [userFullName, setUserFullName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [userList, setUserList] = useState([]);
  const [filteredUserList, setFilteredUserList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            console.log("res", res);
            setCompanyName(res.companyName);
            setUserFullName(`${res.firstName} ${res.lastName}`);
          });
          setIsCompanyNameFetched(true);
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  const handleNewKeys = () => {
    navigate(`/key/new_key/${id}`);
  };

  const [owner, setOwners] = useState([]);

  useEffect(() => {
    if (companyName) {
      const fetchOwners = async () => {
        try {
          const ownerRef = collection(db, "companies", companyName, "owners");
          const snapshot = await getDocs(ownerRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            value: doc.id,
            label:
              doc.data().ownerInfo.firstName +
              " " +
              doc.data().ownerInfo.lastName,
            ...doc.data(),
          }));
          setOwners(fetchedData);
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchOwners();
    }
  }, [companyName]);

  const [dataObject, setdataObject] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [activitiesData, setActivities] = useState([]);
  const [idOfActivity, setIdOfActivity] = useState("");
  const [isActivityFetched, setIsActivityFetched] = useState(false);
  const updateData = (isEdit) => {
    setIsUpdate(isEdit);
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const fetchProperty = () => {
    setIsLoading(true);
    try {
      const companiesRef = collection(db, "companies");
      const propertyRef = doc(companiesRef, companyName, "properties", id);
  
      const unsubscribe = onSnapshot(propertyRef, (doc) => {
        if (!doc.exists) {
          console.log("Document does not exist!");
          setIsLoading(false);
          return;
        }
        console.log("Received property snapshot:", doc.data()); // Debugging line
        const propertyData = { id: doc.id, ...doc.data() };
        setdataObject(propertyData);
        setIsLoading(false);
        updateData(false);
      });
  
      return unsubscribe; 
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };
  

  const fetchActivities = () => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const activitiesRef = collection(companyDocRef, "activities");

    const unsubscribe = onSnapshot(
    activitiesRef,
    (querySnapshot) => {
      console.log("Received activities snapshot:", querySnapshot.docs); // Debugging line

      const matchingActivities = querySnapshot.docs
        .filter((doc) => doc.data().propertyId === id)
        .map((doc) => {
          const activityId = doc.id;
          return { ...doc.data(), activityId };
        });

      
        if (!matchingActivities) {
          localStorage.removeItem("id");
        } else {
          localStorage.setItem("id", idOfActivity);
        }

        let newData = matchingActivities?.reduce((acc, item) => {
          let filteredActivities = item.propertiesActivities.filter(
            (activity) => activity.assignTo === user?.uid
          );
          if (filteredActivities?.length > 0) {
            acc.push({ ...item, propertiesActivities: filteredActivities });
          }
          return acc;
        }, []);

        console.log("newData Activities: ", newData);
        setActivities(newData);
        setIsActivityFetched(true);

    },
    (error) => {
      console.log("Error fetching activities: ", error);
      setIsActivityFetched(true);
    }
  );

    return unsubscribe;
  };

  useEffect(() => {
    if (!isCompanyNameFetched) return;
  
    console.log("Running useEffect for:", companyName, isCompanyNameFetched); // Debugging line
    
    const unsubscribeProperty = fetchProperty();
    const unsubscribeActivities = fetchActivities();
  
    return () => {
      unsubscribeProperty();
      unsubscribeActivities();
    };
  }, [companyName, isCompanyNameFetched]);

  useEffect(() => {
    if (companyName && dataObject) {
      const fetchUserList = async () => {
        try {
          const userRef = collection(db, "companies", companyName, "users");
          const snapshot = await getDocs(userRef);
          let fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            value: doc.id,
            label:
              doc.data().profile.firstName + " " + doc.data().profile.lastName,
            ...doc.data(),
          }));

          // Extract unique keyHolder IDs from propertyData
          const keyHolderIDs = new Set();
          for (const keyItem of dataObject?.keys) {
            if (keyItem.keyHolder && Array.isArray(keyItem.keyHolder)) {
              for (const holder of keyItem.keyHolder) {
                if (holder.keyHolder) {
                  keyHolderIDs.add(holder.keyHolder);
                }
              }
            }
          }

          const filterkeyHolderIDs = [];
          dataObject?.keys.forEach((keyItem) => {
            if (keyItem.keyHolder && keyItem.keyHolder.length > 0) {
              keyItem.keyHolder.forEach((holder) => {
                if (holder.keyHolder) {
                  filterkeyHolderIDs.push(holder.keyHolder);
                }
              });
            }
          });
          const filterData = fetchedData?.filter((user) =>
            filterkeyHolderIDs.includes(user.id)
          );

          fetchedData = fetchedData?.filter(
            (user) => !keyHolderIDs?.has(user.id)
          );

          console.log("Filtered fetchedData:", filterData);
          setUserList(fetchedData);
          setFilteredUserList(filterData);
        } catch (err) {
          console.error(err);
        }
      };
      fetchUserList();
    }
  }, [companyName, dataObject]);


  const tableHeader = [
    {
      title: "Key Id",
      dataIndex: "keyID",
      key: "keyID",

      render: (_, document, index) => (
        <NavLink to={`/key/new_key/${id}?edit=${index}`}>
          <span className="onclick-text">{document.keyID}</span>
        </NavLink>
      ),
    },
    {
      title: "Description",
      dataIndex: "Description",
      key: "Description",
      render: (_, document) => <span>{document.Description}</span>,
    },
    {
      title: "Available",
      dataIndex: "TotalKeys",
      key: "TotalKeys",
      render: (_, document) => (
        <span>{`${document.keyHolder.length} / ${document.TotalKeys}`} </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "Actions",
      key: "Actions",
      render: (_, document) => (
        <p>
          {document.keyHolder.length == document.TotalKeys ? null : (
            <a onClick={() => showKeyModal(document.keyID, "add")}>
              Check Out{" "}
            </a>
          )}
          <br />
          {document.keyHolder.length > 0 && (
            <a onClick={() => showKeyModal(document.keyID, "update")}>
              return{" "}
            </a>
          )}
        </p>
      ),
    },
  ];

  const setPropertyHidden = async () => {
    const companiesRef = collection(db, "companies");
    const propertyRef = doc(companiesRef, companyName, "properties", id);

    const propertyStatus = {
      propertyHidden: true,
      propertyHidingReason: hidingReason ? hidingReason : "",
    };
    try {
      await updateDoc(propertyRef, propertyStatus);
      toast.success("Property updated successfully");
      setIsHidePropertyShow(false);
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const [accounts, setAccounts] = useState([
    { id: uuidv4(), ownerId: "", percentOwned: "", contractExpires: "" },
  ]);

  useEffect(() => {
    if (companyName) {
      const fetchProperties = async () => {
        try {
          const PropertyRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(PropertyRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          const filteredProperty = fetchedData.find((item) => item.id === id);

          const owner = filteredProperty.ownerAndFinancials;

          function areAllObjectFieldsEmpty(obj) {
            for (const key in obj) {
              if (
                obj.hasOwnProperty(key) &&
                typeof obj[key] === "string" &&
                obj[key].trim() !== ""
              ) {
                return false; // At least one non-empty field found
              }
            }
            return true; // All fields are empty
          }

          const result = areAllObjectFieldsEmpty(owner);
          setOwnership(result);
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchProperties();
    }
  }, [companyName, newOwnerShipShow]);

  const handleInputChange = (value, name, id) => {
    const updatedAccounts = accounts.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setAccounts(updatedAccounts);
  };

  const handleDateChange = (value, name, id) => {
    const updatedAccounts = accounts.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value.format("YYYY-MM-DD") };
      }
      return item;
    });
    setAccounts(updatedAccounts);
  };

  const addAccount = () => {
    const newAccount = {
      id: uuidv4(),
      ownerId: "",
      percentOwned: "",
      contractExpires: "",
    };
    setAccounts([...accounts, newAccount]);
  };

  const removeAccount = (id) => {
    const updatedAccounts = accounts.filter((item) => item.id !== id);
    setAccounts(updatedAccounts);
  };

  const onFinish = (values) => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const propertyDocRef = doc(companyDocRef, "properties", id);

    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });

    try {
      updateDoc(propertyDocRef, {
        ownerAndFinancials: {
          basisForOwnerPackets: values.basisForOwnerPackets,
          fiscalYearEnd: values.fiscalYearEnd,
          ownershipStartDate: values.ownershipStartDate
            ? values.ownershipStartDate.format("YYYY-MM-DD")
            : "",
          paymentType: values.paymentType,
          reservedFunds: values.reservedFunds,
          vendor1099: values.vendor1099,
        },
        "ownerAndFinancials.owners": accounts,
      });
      toast.success("Updated successfully");
      setNewOwnerShipShow(false);
    } catch (error) {
      console.error("not updated:", error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const [isWaiting, setIsWaiting] = useState(false);

  const checkOutKeyFinish = async (values) => {
    setIsWaiting(true);
    const sanitizedValues = Object.keys(values).reduce((acc, key) => {
      acc[key] = values[key] || ""; // If value is undefined or empty, set it to ""
      return acc;
    }, {});

    try {
      const companiesRef = collection(db, "companies");
      const propertyDocRef = doc(companiesRef, companyName, "properties", id);

      // Fetching the data
      const docSnapshot = await getDoc(propertyDocRef);
      if (!docSnapshot.exists()) {
        console.error("Document does not exist!");
        return;
      }

      const propertyData = docSnapshot.data();

      if (isUpdateValue) {
        // Iterate over the keys array and find the matching keyID to update
        propertyData.keys = propertyData.keys.map((keyItem) => {
          if (keyItem.keyID === keyId) {
            // If keyHolder exists, filter out the matching keyHolder
            if (keyItem.keyHolder) {
              keyItem.keyHolder = keyItem.keyHolder.filter(
                (holder) => holder.keyHolder !== values.keyHolder
              );
            }
          }
          return keyItem;
        });
      } else {
        // Iterate over the keys array and find the matching keyID to update
        propertyData.keys = propertyData.keys.map((keyItem) => {
          if (keyItem.keyID === keyId) {
            // If keyHolder doesn't exist, initialize it as an array
            if (!keyItem.keyHolder) {
              keyItem.keyHolder = [];
            }

            // Push the new data to keyHolder array
            keyItem.keyHolder.push(sanitizedValues);
          }
          return keyItem;
        });
      }

      // Update the data in Firestore
      await updateDoc(propertyDocRef, {
        keys: propertyData.keys,
      });
      setIsWaiting(false);

      isUpdateValue
        ? toast.success("Key returned!")
        : toast.success("Key holder data added successfully!");
      setIsKeyModalOpen(false);
      setIsUpdate(true);
    } catch (error) {
      console.error("Error adding key holder data: ", error);
      setIsWaiting(true);
    }
  };

  const checkOutKeyFinishFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      {isLoading ? (
        <Spin tip="Loading" size="large">
          <div className="content" />
        </Spin>
      ) : (
        <div className="PropertyItemPage">
          <Row gutter={16} justify="space-between">
            <Col span={6}>
              {dataObject && (
                <img
                  src={
                    dataObject?.attachments &&
                    dataObject?.attachments[0]?.downloadURL
                      ? dataObject?.attachments[0]?.downloadURL
                      : PropertyImg
                  }
                  alt="PropertyImg"
                  style={{ padding: "20px", height: "100%", width: "100%" }}
                />
              )}
            </Col>
            <Col span={18}>
              {dataObject && (
                <AboutProperty
                  data={dataObject?.propertyNameAddress}
                  dataId={dataObject?.id}
                  isUpdate={updateData}
                  companyName={companyName}
                />
              )}
            </Col>
          </Row>
          <br />
          {isActivityFetched && (
            <UpComingActivities
              activities={activitiesData}
              userFullName={userFullName}
              companyName={companyName}
            />
          )}
          <br />
          {dataObject && (
            <PropertyInformation
              data={dataObject?.propertyInformation}
              dataId={dataObject?.id}
              isUpdate={updateData}
              companyName={companyName}
            />
          )}
          <br />
          {dataObject && (
            <NonRevenueStatus
              data={dataObject?.nonRevenueStatus}
              dataId={dataObject?.id}
              isUpdate={updateData}
              companyName={companyName}
            />
          )}
          <br />
          {dataObject && (
            <RentalInformation
              data={dataObject?.rentalInformation}
              dataId={dataObject?.id}
              isUpdate={updateData}
              companyName={companyName}
            />
          )}
          <br />
          {dataObject && (
            <Amenities
              data={dataObject?.amenities}
              dataId={dataObject?.id}
              isUpdate={updateData}
              companyName={companyName}
            />
          )}
          {/* <br />
       <Card title="Current Tenants">
         <Table
            columns={dataObject.currentTenants.tableColumns}
            dataSource={dataObject.currentTenants.tableData}
            pagination={false}
          />
          <br />
          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
            colon={false}
          >
            <Form.Item label="Lease Terms">
              <p>
                {dataObject.currentTenants.leaseTerms === ""
                  ? "--"
                  : dataObject.currentTenants.leaseTerms}
              </p>
            </Form.Item>
            <Form.Item label="Deposits Paid">
              <p>
                {dataObject.currentTenants.depositsPaid === ""
                  ? "--"
                  : dataObject.currentTenants.depositsPaid}
              </p>
            </Form.Item>
          </Form> 
        </Card>*/}
          <br />
          {dataObject && (
            <MarketingInformation
              data={dataObject?.marketingInformation}
              dataId={dataObject?.id}
              isUpdate={updateData}
              companyName={companyName}
            />
          )}
          <br />
          {dataObject && (
            <LeaseSetting
              data={dataObject?.leaseSettings}
              dataId={dataObject?.id}
              isUpdate={updateData}
              companyName={companyName}
            />
          )}
          <br />
          {dataObject && (
            <OwnersAndFinancial
              data={dataObject?.ownerAndFinancials}
              dt={dataObject?.ownerAndFinancials}
              dataId={dataObject?.id}
              isUpdate={updateData}
              companyName={companyName}
            />
          )}
          <br />
          {dataObject && (
            <ManagementFees
              data={dataObject?.managementFees}
              dt={dataObject}
              isUpdate={updateData}
              dataId={dataObject?.id}
              companyName={companyName}
            />
          )}
          <br />
          {dataObject && (
            <AdditionalFees
              data={dataObject?.additionalFees}
              isUpdate={updateData}
              dataId={dataObject?.id}
            />
          )}
          <br />
          {/* Late Fee Policy Start... */}
          {dataObject && (
            <LateFeePolicy
              data={dataObject?.LateFeePolicy}
              dataId={dataObject?.id}
            />
          )}
          {/* Late Fee Policy End... */}
          <br />
          {dataObject && (
            <Card
              title="Keys"
              extra={
                <Button onClick={handleNewKeys}>
                  <i
                    className="fa-solid fa-circle-plus"
                    style={{ marginRight: "5px" }}
                  ></i>{" "}
                  Add Key
                </Button>
              }
            >
              {/* {console.log("Data =====>>>", dataObject?.keys)} */}

              <Table
                columns={tableHeader}
                dataSource={dataObject?.keys}
                size="small"
              />
            </Card>
          )}
          <br />
          {dataObject && (
            <MaintenanceInformation
              data={dataObject?.maintenanceInformation}
              company={companyName}
              dataId={dataObject?.id}
            />
          )}
          <br />
          {dataObject && (
            <PropertyGroups
              data={dataObject?.propertyGroups}
              companyName={companyName}
              dataId={dataObject?.id}
              isCompanyNameFetched={isCompanyNameFetched}
            />
          )}
          <br />
          {/* {dataObject && (
          <StatementSettings
            data={dataObject?.statementSettings}
            company={companyName}
            dataId={dataObject?.id}
          />
        )} */}
          <br />
          {dataObject && (
            <BankAccounts
              data={dataObject?.bankAccounts}
              isUpdate={updateData}
              dataId={dataObject?.id}
              companyName={companyName}
            />
          )}
          {/* Upload photo  */}
          <br />
          {companyName && dataObject ? (
            <Notes
              notesForCollection="properties"
              notesForCollectionId={dataObject?.id}
              companyName={companyName}
              notes={notes}
              setNotes={setNotes}
            />
          ) : null}
          {/* Audit Log  */}
          <br />
          {dataObject ? (
            <AttachmentsUpload
              id={id}
              data={dataObject?.attachments}
              companyName={companyName}
              collection="properties"
            />
          ) : null}
          <div className="RightSidebar">
            <RightBar RightBarData={PropertyRightbar} />
          </div>
          {newOwnerShipShow && (
            <ConfirmationBox setIsConfirmationBoxOpen={setNewOwnerShipShow}>
              <h2>New Ownership</h2>
              <Form
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 11 }}
                colon={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Row className="new-ownership" gutter={[0, 8]}>
                  <Col span={24}>
                    <Form.Item
                      label="Ownership Start Date"
                      required
                      rules={{ required: true, message: "Can't be blank" }}
                      name="ownershipStartDate"
                    >
                      <DatePicker style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Row>
                      <Col span={22}>
                        <Row className="header-row">
                          <Col span={8}>
                            <span>Owner</span>
                          </Col>
                          <Col span={8}>
                            <span>Percent Owned</span>
                          </Col>
                          <Col span={6}>
                            <span>Contract Expires</span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {accounts.map((item, index) => {
                      return (
                        <Row
                          align="middle"
                          gutter={[18, 0]}
                          className="data-row"
                        >
                          <Col span={22}>
                            <Row align="middle">
                              <Col span={8}>
                                <Select
                                  style={{ width: "100%" }}
                                  options={owner}
                                  placeholder="Start typing to search"
                                  allowClear
                                  showSearch
                                  onChange={(value) =>
                                    handleInputChange(value, "ownerId", item.id)
                                  }
                                />
                              </Col>
                              <Col span={8}>
                                <InputNumber
                                  placeholder="Enter Percent Owned"
                                  name="percent"
                                  style={{ width: "100%" }}
                                  onChange={(value) =>
                                    handleInputChange(
                                      value,
                                      "percentOwned",
                                      item.id
                                    )
                                  }
                                />
                              </Col>
                              <Col span={8}>
                                <DatePicker
                                  style={{ width: "100%" }}
                                  onChange={(value) =>
                                    handleDateChange(
                                      value,
                                      "contractExpires",
                                      item.id
                                    )
                                  }
                                />
                              </Col>
                            </Row>
                          </Col>
                          {accounts.length > 1 ? (
                            <Col span={2}>
                              <RiCloseCircleLine
                                size={22}
                                className="delete-icon"
                                onClick={() => removeAccount(item.id)}
                              />
                            </Col>
                          ) : null}
                        </Row>
                      );
                    })}
                    <Button className="add-owner-btn" onClick={addAccount}>
                      <RiAddCircleFill size={18} />{" "}
                      <span>Add Another Owner</span>
                    </Button>
                  </Col>
                  <Col span={24}>
                    <p className="center-text">Total: {totalPercentage}%</p>
                  </Col>
                  <Col span={24}>
                    <p className="onclick-text">Create New Owner</p>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Payment Type" name="paymentType">
                      <Radio.Group onChange={onChange} value={value}>
                        <Radio value="net income">Net Income</Radio>
                        <Radio value="flat">Flat</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Reserve Funds"
                      name="reservedFunds"
                      required
                    >
                      <InputNumber
                        style={{ width: "100%" }}
                        placeholder="Reserve Funds"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Vendor 1099 Payer" name="vendor1099">
                      <Select options={payee} placeholder="Select" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Fiscal Year End" name="fiscalYearEnd">
                      <Select options={months} placeholder="Select" />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      label="Basis for Owner Packets"
                      name="basisForOwnerPackets"
                    >
                      <Select options={packets} placeholder="Select" />
                    </Form.Item>
                  </Col>
                </Row>
                <div className="action-buttons">
                  <Button type="primary" htmlType="submit">
                    Save
                  </Button>
                  <button
                    className="cancel-btn"
                    onClick={() => setNewOwnerShipShow(false)}
                  >
                    Cancel
                  </button>
                </div>
              </Form>
            </ConfirmationBox>
          )}
        </div>
      )}
      {postToWebsiteOpen ? (
        <PostToWebsite
          setIsConfirmationBoxOpen={setPostToWebsiteOpen}
        ></PostToWebsite>
      ) : null}
      {postToInternetOpen ? (
        <PostToInternet
          setIsConfirmationBoxOpen={setPostToInternetOpen}
        ></PostToInternet>
      ) : null}
      {/* {newOwnerShipShow ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setNewOwnerShipShow}>
          <h2>New Ownership</h2>
          <Form labelCol={{ span: 8 }} wrapperCol={{ span: 11 }} colon={false}>
            <Row className="new-ownership" gutter={[0, 8]}>
              <Col span={24}>
                <Form.Item label="Ownership Start Date" required>
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Row>
                  <Col span={22}>
                    <Row className="header-row">
                      <Col span={8}>
                        <span>Owner</span>
                      </Col>
                      <Col span={8}>
                        <span>Percent Owned</span>
                      </Col>
                      <Col span={6}>
                        <span>Contract Expires</span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {inputFields.map((item, index) => {
                  return (
                    <Row align="middle" gutter={[18, 0]} className="data-row">
                      <Col span={22}>
                        <Row align="middle">
                          <Col span={8}>
                            <Select
                              style={{ width: "100%" }}
                              options={contactinfo}
                              placeholder="Start typing to search"
                              allowClear
                              showSearch
                            />
                          </Col>
                          <Col span={8}>
                            <InputNumber
                              placeholder="Enter Percent Owned"
                              name="percent"
                              value={item.percent}
                              onChange={(event) => handleChange(index, event)}
                              style={{ width: "100%" }}
                            />
                          </Col>
                          <Col span={8}>
                            <DatePicker style={{ width: "100%" }} />
                          </Col>
                        </Row>
                      </Col>
                      {inputFields.length > 1 ? (
                        <Col span={2}>
                          <RiCloseCircleLine
                            size={22}
                            className="delete-icon"
                            onClick={() => removeInputFields(index)}
                          />
                        </Col>
                      ) : null}
                    </Row>
                  );
                })}
                <button
                  className="add-owner-btn"
                  onClick={() => addInputField()}
                >
                  <RiAddCircleFill size={18} /> <span>Add Another Owner</span>
                </button>
              </Col>
              <Col span={24}>
                <p className="center-text">Total: {totalPercentage}%</p>
              </Col>
              <Col span={24}>
                <p className="onclick-text">Create New Owner</p>
              </Col>
              <Col span={24}>
                <Form.Item label="Payment Type">
                  <Radio.Group onChange={onChange} value={value}>
                    <Radio value="net income">Net Income</Radio>
                    <Radio value="flat">Flat</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Reserve Funds" required>
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder="Reserve Funds"
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Vendor 1099 Payer">
                  <Select options={payee} placeholder="Select" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Fiscal Year End">
                  <Select options={months} placeholder="Select" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Basis for Owner Packets">
                  <Select options={packets} placeholder="Select" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div className="action-buttons">
            <Button type="primary" onClick={() => setNewOwnerShipShow(false)}>
              Save
            </Button>
            <button
              className="cancel-btn"
              onClick={() => setNewOwnerShipShow(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null} */}
      {isHidePropertyShow ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsHidePropertyShow}>
          <h2>3 Warnings</h2>
          <ul className="hide-list">
            <li>
              <span>
                Hiding this property will also hide all tenants associated with
                it.
              </span>
            </li>
            <li>
              <span>
                View and complete open items for recently closed out properties
                on the <span className="onclick-text">End Management</span>{" "}
                page.
              </span>
            </li>
            <li>
              <span>
                This Property has non zero account balances, outstanding bills,
                and outstanding charges.
              </span>
            </li>
          </ul>
          <Select
            options={[{ value: "Sold Out" }, { value: "Relacement" }]}
            value={hidingReason}
            onChange={(value) => setHidingReason(value)}
          />
          <div className="action-buttons">
            <Button type="primary" onClick={() => setPropertyHidden()}>
              Hide
            </Button>
            <button
              className="cancel-btn"
              onClick={() => setIsHidePropertyShow(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}
      {textPropertyShow ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setTextPropertyShow}>
          <h2>Send Bulk Text</h2>
          {/* <p className="tenant-property">
            None of the tenants in this property will be able to receive this
            message. (<span className="onclick-text">Why?</span>)
          </p> */}
          <Form layout="vertical">
            <Form.Item label="Recipients" required>
              <TextArea
                rows={3}
                placeholder="William Sunken"
                defaultValue="William Sunken"
                disabled
              />
            </Form.Item>
            <Form.Item label="Message" required>
              <TextArea
                rows={3}
                onChange={(e) => setCount(e.target.value.length)}
                maxLength="300"
              />
            </Form.Item>
            <p>{count} / 300 Characters</p>
            <div className="action-buttons">
              <Button type="primary">Send</Button>
              <button className="cancel-btn">Cancel</button>
            </div>
          </Form>
        </ConfirmationBox>
      ) : null}

      {isConfirmationBoxOpen ? (
        <EmailRentalApplication
          isConfirmationBoxOpen={isConfirmationBoxOpen}
          setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}
        />
      ) : null}

      <Modal
        title="Check Out Key"
        open={isKeyModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          name="basic"
          layout="vertical"
          onFinish={checkOutKeyFinish}
          onFinishFailed={checkOutKeyFinishFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Key Holder"
            name="keyHolder"
            rules={[
              {
                required: true,
                message: "can't be blank!",
              },
            ]}
          >
            <Select
              style={{
                width: "100%",
              }}
              options={isUpdateValue ? filteredUserList : userList}
            />
          </Form.Item>

          <Form.Item label="Comments" name="comments">
            <TextArea />
          </Form.Item>
          <Form.Item>
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isWaiting}>
                  {isWaiting ? "Wait..." : "Submit"}
                </Button>
              </Col>
              <Col>
                <Button onClick={handleCancel}>Cancel</Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </Modal>
      <Email
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        emailTo="property"
      />
    </>
  );
};

export default PropertyItemPage;
